import { useEffect, useState } from "react";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import OPHDashboard from "./ophDashboard/OPHDashboard";
import OPHGraph from "./ophGraph/OPHGraph";
import OPHTracker from "./ophTracker/OPHTracker";
import moment from "moment";
import { exportOPHData } from "../../actions/oph";
import RadioGroup from "devextreme-react/radio-group";
import DateBox from "devextreme-react/date-box";
import { postUserLog } from "../../actions/common";

import Graph from "./ophGraph/Graph";

const OPH = (props) => {
  const { site, tier, title, isEditable, siteInformation, lastUpdatedOn } = {
    ...props,
  };
  const [refresh, setRefresh] = useState(new Date().getTime());
  const { isLoading, isSuccess, isError, error, data } = useOPHList(
    parseInt(tier),
    refresh
  );
  const ophMissReasonCodes = useOPHMissReasonCodes(site, tier, refresh);
  const [ophId, setOPHId] = useState(0);
  const [siteDate, setSiteDate] = useState(lastUpdatedOn);
  const [showExportForm, setShowExportForm] = useState(false);
  const [exportFilter, setExportFilter] = useState(0);
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const onExporting = () => {
    let startDate = moment(sDate).format("DD/MM/YYYY"),
      endDate = moment(eDate).format("DD/MM/YYYY");
    let startDateLog = moment(sDate).format("YYYY-MM-DD"),
      endDateLog = moment(eDate).format("YYYY-MM-DD");

    postUserLog({
      event: "Export",
      data: {
        action:
          exportFilter == 2
            ? `Date Range[${startDateLog} to ${endDateLog}] exported`
            : "All exported" + "",
        module: "Digital Tier",
        section: props.moduleName,
        siteUId: site,
        widget: "OPH TRACKER",
        tierId: tier,
      },
    });
    exportOPHData(
      "OPH Tracker",
      `digitaltier/exportOPHDetails?siteId=${site}&tierId=${tier}&startDate=${startDate}&isall=${
        exportFilter == 2 ? false : true
      }&endDate=${endDate}&prodId=${ophId}`
    );
  };

  return (
    <div style={{ margin: "0px" }} className="col" key="oph-tracker">
      <div className="col-heading">{title}</div>

      {ophMissReasonCodes.isSuccess && (
        <div className="col-body">
          <div className="create-posts" style={{ marginTop: "-54px" }}>
            <span
              onClick={() => {
                setShowExportForm(!showExportForm);
              }}
            >
              <i className="fas fa-file-export"></i>Export
            </span>
          </div>
          {showExportForm && (
            <div
              className="m-w-572"
              style={{ width: "100%", maxWidth: "100%" }}
            >
              <div>
                <RadioGroup
                  items={[
                    { id: 0, text: "All" },
                    { id: 2, text: "Date range" },
                  ]}
                  value={exportFilter}
                  valueExpr="id"
                  displayExpr="text"
                  onValueChanged={(e) => setExportFilter(e.value)}
                  layout="horizontal"
                />
              </div>
              <div
                className="d-flex"
                style={{
                  alignItems: "flex-end",
                  flexWrap: "wrap",
                  width: "100%",
                  padding: "10px",
                }}
              >
                {exportFilter == 2 && (
                  <div className="alert-container">
                    <span>
                      Start date:{" "}
                      <DateBox
                        value={sDate}
                        onValueChanged={(e) => setSDate(e.value)}
                        useMaskBehavior={true}
                        type="date"
                      />
                    </span>
                    <span style={{ marginLeft: "10px" }}>
                      End date:{" "}
                      <DateBox
                        value={eDate}
                        onValueChanged={(e) => setEDate(e.value)}
                        type="date"
                        useMaskBehavior={true}
                      />
                    </span>
                  </div>
                )}
                <div className="cbtn d-flex justify-space-between align-items-center">
                  <button
                    onClick={(e) => onExporting(e)}
                    className="btn secondary-btn"
                  >
                    Export
                  </button>
                  <button
                    onClick={() => {
                      setShowExportForm(!showExportForm);
                    }}
                    className="btn primary-btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          <OPHDashboard
            site={site}
            tier={tier}
            ophList={data}
            ophId={ophId}
            setRefresh={setRefresh}
            setOPHId={setOPHId}
            siteDate={siteDate}
            setSiteDate={setSiteDate}
            missReasonCodes={ophMissReasonCodes.data}
            isEditable={isEditable}
            siteInformation={siteInformation}
            lastUpdatedOn={lastUpdatedOn}
            moduleTitle={props.moduleName}
          />
        </div>
      )}
      {ophId && (
        //true && (
        <div className="col-body">
          {/* <OPHGraph
            site={site}
            tier={tier}
            ophId={ophId}
            setRefresh={setRefresh}
            siteDate={siteDate}
            setSiteDate={setSiteDate}
            refresh={refresh}
            missReasonCodes={ophMissReasonCodes.data}
            moduleTitle={props.moduleName}
          /> */}

          <Graph
            siteId={site}
            tierId={tier}
            siteDate={siteDate}
            moduleName={props.moduleName}
          />
        </div>
      )}
      <div className="col-body">
        {
          //{ isLoading && <div> Loading ... </div>}
          //{isSuccess
          //    &&
          //    <OPHTracker site={site} tier={tier} ophList={data} setRefresh={setRefresh} setOPHId={setOPHId} />
          //}
          //{isError && <div> {error} </div>}
        }
      </div>
    </div>
  );
};

const useOPHList = (tierid, refresh) => {
  const [response, setResponse] = useState({
    data: null,
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  });
  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_OPH_LIST_BY_TIER + tierid,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res.status === 200) {
        setResponse({
          data: res.data,
          isLoading: false,
          isSuccess: true,
          isError: false,
          error: null,
        });
      } else {
        setResponse({
          data: res.data,
          isLoading: false,
          isSuccess: false,
          isError: true,
          error: "Error Loading OPH List",
        });
      }
    });
  }, [refresh]);
  return response;
};

const useOPHMissReasonCodes = (siteId, tierId, refresh) => {
  const [response, setResponse] = useState({
    data: null,
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  });
  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_OPH_MISS_REASON_CODES + siteId + "&tierId=" + tierId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res.status === 200) {
        setResponse({
          data: res.data,
          isLoading: false,
          isSuccess: true,
          isError: false,
          error: null,
        });
      } else {
        setResponse({
          data: res.data,
          isLoading: false,
          isSuccess: false,
          isError: true,
          error: "Error Loading OPH Miss Reason Codes",
        });
      }
    });
  }, [refresh]);
  return response;
};

export default OPH;
